import { questionTypes } from "../../../utils/LearningPathUtils";
import { Scq } from "../optionLayouts/Scq";
import { useState } from "react";
import { Mcq } from "../optionLayouts/Mcq";
import { Fib } from "../optionLayouts/Fib";

export const AnswersLayout = (props) => {
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [onSubmitClicked, setOnSubmitClicked] = useState(
    props.onAnswerSubmitted
  );
  const onSubmitReceive = (data) => {
    props.onSend(data);
  };

  const handleAnswerChange = (item) => {
    setSelectedAnswer(item.selectedItem);
    props.onSend({
      answer: item.selectedItem,
      hashedIndexAnswer: item.selectedHashedIndexAnswer,
      selectedIndex: item.selectedIndex,
    });
  };

  return (
    <div id="answers-layout">
      {props.question_type === questionTypes.mcq && (
        <Mcq
          data-testid="mcq-component"
          key={props?.question}
          userAnswer={props?.userAnswer}
          question_type={props?.question_type}
          question_id={props?.question_id}
          question={props?.question}
          options={props?.options}
          modifiedOptions={props?.modifiedOptions}
          answer={props?.answers}
          handleAnswerChange={handleAnswerChange}
          images_details={props?.images_details}
          option_image_details={props?.option_image_details}
          isDisabled={props?.isDisabled}
          onSend={onSubmitReceive}
          onAnswerSubmitted={props.onAnswerSubmitted}
          isDontAllow={props?.isDontAllow || false}
          currentQuestion={props?.currentQuestion}
          taskType={props.taskType}
        />
      )}
      {(props.question_type === questionTypes.fib ||
        props.question === questionTypes.drag_fib) && (
        <Fib
          data-testid="fib-component"
          key={props?.question}
          userAnswer={props?.userAnswer}
          question_type={props?.question_type}
          question_id={props?.question_id}
          options={props?.options}
          question={props?.question}
          answer={props?.answers}
          handleAnswerChange={handleAnswerChange}
          images_details={props?.images_details}
          isDisabled={props?.isDisabled}
          onSend={onSubmitReceive}
          onAnswerSubmitted={props.onAnswerSubmitted}
          isDontAllow={props?.isDontAllow || false}
          allowToCopy={props?.allowToCopy || false}
          currentQuestion={props?.currentQuestion}
          taskType={props.taskType}
        />
      )}
      {(props.question_type === questionTypes.nav ||
        props.question_type === questionTypes.scq ||
        props.question_type === questionTypes.reason_assertion ||
        props.question_type === questionTypes.tf ||
        props.question_type === questionTypes.yn ||
        props.question_type === questionTypes.sorting ||
        props.question_type === questionTypes.match) && (
        <Scq
          data-testid="scq-component"
          displayedQues={props?.displayedQues}
          key={props?.question}
          userAnswer={props?.userAnswer}
          question_type={props?.question_type}
          question_id={props?.question_id}
          options={props?.options}
          modifiedOptions={props?.modifiedOptions}
          answer={props?.answers}
          question={props?.question}
          handleAnswerChange={handleAnswerChange}
          images_details={props?.images_details}
          option_image_details={props?.option_image_details}
          isDisabled={props?.isDisabled}
          onSend={onSubmitReceive}
          onAnswerSubmitted={props.onAnswerSubmitted}
          isDontAllow={props?.isDontAllow || false}
          currentQuestion={props?.currentQuestion}
          taskType={props.taskType}
        />
      )}
      {/* {props.question_type === questionTypes.match && (
        <MatchTheFollowing
          data-testid="match-component"
          key={props?.question}
          question_type={props?.question_type}
          question_id={props?.question_id}
          options={props?.options}
          question={props?.question}
          answer={props?.answers}
          images_details={props?.images_details}
          isDisabled={props?.isDisabled}
          onSend={onSubmitReceive}
        />
      )} */}
      {/* {props.question_type === questionTypes.sorting && (
        <Sorting
          data-testid="sorting-component"
          key={props?.question}
          question_type={props?.question_type}
          question_id={props?.question_id}
          options={props?.options}
          question={props?.question}
          images_details={props?.images_details}
          isDisabled={props?.isDisabled}
          onSend={onSubmitReceive}
        />
      )} */}
      {/* {props.question_type === questionTypes.drag_fib && (
        <DraggableFib
          data-testid="drag-fib-component"
          key={props?.question}
          question_type={props?.question_type}
          question_id={props?.question_id}
          options={props?.options}
          answer={props?.answers}
          question={props?.question}
          images_details={props?.images_details}
          isDisabled={props?.isDisabled}
          onSend={onSubmitReceive}
        />
      )} */}
    </div>
  );
};
